import { render, staticRenderFns } from "./SyncTaskProgress.vue?vue&type=template&id=6c5566ba"
import script from "./SyncTaskProgress.vue?vue&type=script&lang=js"
export * from "./SyncTaskProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports